/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import { Icon } from 'learning-panel-components';
import { translate } from 'translations';
import Gallery from '../assessments/gallery/gallery';
import styles from './cardsGallery.module.scss';

interface CardsGalleryProps {
    customGrids: React.ReactNode[];
    hover: boolean;
    setHover: (hover: boolean) => void;
    numOfPages: number;
    total: number;
    title: string;
    columns: number;
    infoTitle?: string;
    infoDescription?: string;
}

const CardsGallery: FC<CardsGalleryProps> = ({
    customGrids,
    hover,
    setHover,
    numOfPages,
    total,
    title,
    columns,
    infoTitle,
    infoDescription
}: CardsGalleryProps) => {
    return (
        <div
            className={styles['gallery-cards-wrapper']}
            style={{ '--gridWidth': `${columns === 2 ? columns * 24 : columns * 24}rem` } as any}
        >
            <div className={styles.top}>
                <div className={styles['top-left']}>
                    <span className={styles['left-title']}>{translate(title)}&nbsp;</span>
                    <span className={styles['left-number']}>({total})</span>
                    {infoDescription && (
                        <div
                            onMouseEnter={() => {
                                setHover(true);
                            }}
                            onMouseLeave={() => {
                                setHover(false);
                            }}
                            className={styles}
                        >
                            <Icon name="info" className={styles.icon} />
                        </div>
                    )}
                    {hover && infoDescription && (
                        <div className={styles['info-box']}>
                            {infoTitle && <div className={styles.title}>{infoTitle}</div>}
                            <div className={styles.description}>{infoDescription}</div>
                        </div>
                    )}
                </div>
            </div>
            {numOfPages > 1 ? (
                <Gallery topAction numberOfElements={numOfPages}>
                    {customGrids}
                </Gallery>
            ) : (
                <div>{customGrids}</div>
            )}
        </div>
    );
};

export default CardsGallery;
